import React, { useRef, useState } from "react";

export type BannerContextType = {
    isCompactBanner: boolean;
    setIsCompactBanner: (value: boolean) => void;
    buttonActionRef?: any;
};

export const BannerContext = React.createContext<BannerContextType | null>(null);

const BannerProvider: React.FC<React.ReactNode> = ({ children }) => {
    const [isCompactBanner, setIsCompactBanner] = useState(false);
    const buttonActionRef = useRef();

    return (
        <BannerContext.Provider
            value={{
                isCompactBanner,
                setIsCompactBanner,
                buttonActionRef,
            }}
        >
            {children}
        </BannerContext.Provider>
    );
};
export default BannerProvider;
